/**
 * Config: Timings
 * -----------------------------------------------------------------------------
 * Global configuration for consistent values for timing durations.
 * - Automatically generated by `design` command, do not edit.
 *
 */
// eslint-disable

export const values = {
  quick: 0.15,
  normal: 0.3,
  slow: 0.5,
  slower: 0.75,
  notification: 1.25,
  skeleton: 2,
  message: 6,
}

export default {
  quick: values.quick * 1000,
  normal: values.normal * 1000,
  slow: values.slow * 1000,
  slower: values.slower * 1000,
  notification: values.notification * 1000,
  skeleton: values.skeleton * 1000,
  message: values.message * 1000,
}
